/*
 * action types for redux actions
 */

export const REGISTER_USER = "REGISTER_USER";
export const LOGIN_USER = "LOGIN_USER";
export const MY_PROFILE = "MY_PROFILE";

export const UPDATE_PROFILE = "UPDATE_PROFILE";

export const LOGOUT = "LOGOUT";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const REGISTRATION_REQUESTS = "REGISTRATION_REQUESTS";
export const ACTIVE_USER = "ACTIVE_USER";
export const VALIDATE_RESET_TOKEN = "VALIDATE_RESET_TOKEN";

export const BUYER_AGENT_LIST = "BUYER_AGENT_LIST";
export const ADMIN_INVITE_AGENT = "ADMIN_INVITE_AGENT";

export const ADMIN_GET_MASTER_TEMPLATE_DATA = "ADMIN_GET_MASTER_TEMPLATE_DATA";
export const ADMIN_UPDATE_MASTER_TEMPLATE_DATA =
  "ADMIN_UPDATE_MASTER_TEMPLATE_DATA";
export const CREATE_EVENT_COMM_MASTER_TEMPLATE =
  "CREATE_EVENT_COMM_MASTER_TEMPLATE";
export const DELETE_EVENT_COMM_MASTER_TEMPLATE =
  "DELETE_EVENT_COMM_MASTER_TEMPLATE";
export const MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID =
  "MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID";
export const CREATE_CAMPAIGN_MASTER_TEMPLATE =
  "CREATE_CAMPAIGN_MASTER_TEMPLATE";
export const COPY_CAMPAIGN_MASTER_TEMPLATE = "COPY_CAMPAIGN_MASTER_TEMPLATE";
export const MASTER_TEMPLATE_GET_ALL_VERIABLE_REF =
  "MASTER_TEMPLATE_GET_ALL_VERIABLE_REF";
export const UPDATE_DEPENDENT_TASKS = "UPDATE_DEPENDENT_TASKS";
export const BUYER_UPDATE_DEPENDENT_TASKS = "BUYER_UPDATE_DEPENDENT_TASKS";

export const GET_CONTINGENCIES = "GET_CONTINGENCIES";
export const CREATE_TRANSACTION = "CREATE_TRANSACTION";
export const GET_TRANSACTION = "GET_TRANSACTION";
export const UPDATE_TRANSACTION = "UPDATE_TRANSACTION";
export const DELETE_TRANSACTION = "DELETE_TRANSACTION";
export const GET_LEAD_SOURCE_OPTIONS = "GET_LEAD_SOURCE_OPTIONS";
export const GET_TIME_ZONE = "GET_TIME_ZONE";

export const GET_CONTACT = "GET_CONTACT";
export const GET_BY_ID_CONTACT = "GET_BY_ID_CONTACT";
export const ADD_CONTACT = "ADD_CONTACT";
export const EDIT_CONTACT = "EDIT_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const GET_ROLES = "GET_ROLES";
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const ADD_ROLES = "ADD_ROLES";

export const BUYER_CREATE_MASTER_TEMPLATE = "BUYER_CREATE_MASTER_TEMPLATE";
export const BUYER_CREATE_TASK = "BUYER_CREATE_TASK";
export const BUYER_DELETE_TASK = "BUYER_DELETE_TASK";
export const BUYER_GET_MASTER_TEMPLATE_DATA = "BUYER_GET_MASTER_TEMPLATE_DATA";
export const BUYER_UPDATE_MASTER_TEMPLATE_DATA =
  "BUYER_UPDATE_MASTER_TEMPLATE_DATA";
export const MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER =
  "MASTER_TEMPLATE_GET_CAMPAIGN_DATA_BY_ID_BUYER";

export const GET_ALL_TRANSACTIONS = "GET_ALL_TRANSACTIONS";
export const UPLOAD_PROPERTY_IMAGE = "UPLOAD_PROPERTY_IMAGE";
export const GET_ALL_TASKS = "GET_ALL_TASKS";
export const GET_SPECIAL_TASKS = "GET_SPECIAL_TASKS";
export const GET_TASK_DETAILS = "GET_TASK_DETAILS";
export const DELETE_TASK = "DELETE_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const CREATE_TASK = "CREATE_TASK";
export const GET_ACTUAL_VALUES = "GET_ACTUAL_VALUES";

export const ADD_COMMENT = "ADD_COMMENT";
export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const VENDORS_LIST = "VENDORS_LIST";
export const REMOVED_REGISTRATION = "REMOVED_REGISTRATION";
export const REMOVED_USER = "REMOVED_USER";
export const GET_UPCOMING_TASKS_DASHBOARD = "GET_UPCOMING_TASKS_DASHBOARD";
export const REJECT_REGISTRATION = "REJECT_REGISTRATION";
export const REJECT_REGISTRATION_LIST = "REJECT_REGISTRATION_LIST";
export const GET_DEPENDENCY_DATA = "GET_DEPENDENCY_DATA";
export const PUT_DEPENDENCY_DATA = "PUT_DEPENDENCY_DATA";

export const GET_ALL_CONTINGENCIES = "GET_ALL_CONTINGENCIES";

export const GET_DOCS = "GET_DOCS";
export const ADD_DOC = "ADD_DOC";
export const UPDATE_DOC = "UPDATE_DOC";
export const UPLOAD_DOC = "UPLOAD_DOC";
export const ARCHIVE_DOC = "ARCHIVE_DOC";
export const REMOVE_DOC = "REMOVE_DOC";
export const FOLDER_LIST = "FOLDER-LIST";
export const MOVE_DOC = "MOVE_DOC";
export const FOLDER_PERMISSION = "FOLDER_PERMISSION";
export const SET_PERMISSION = "SET_PERMISSION";
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const DELETE_DOC = "DELETE_DOC";

export const GET_ALL_VENDOR_TRANSACTIONS = "GET_ALL_VENDOR_TRANSACTIONS";
export const GET_ALL_VENDOR_TASKS = "GET_ALL_VENDOR_TASKS";
export const TRANSACTION_STATUS = "TRANSACTION_STATUS";

export const TRANSACTION_DEPEDENDENT_TASK = "TRANSACTION_DEPEDENDENT_TASK";

export const REMOVE_DEPENDENCY_BUYER = "REMOVE_DEPENDENCY_BUYER";

export const GET_ALL_BUYER_TRANSACTIONS = "GET_ALL_BUYER_TRANSACTIONS";
export const GET_ALL_BUYER_TASKS = "GET_ALL_BUYER_TASKS";

export const CALENDAR_EVENTS = "CALENDAR_EVENTS";

export const TRANSACTION_ACTIVITY = "TRANSACTION_ACTIVITY";
export const TRANSACTION_ACTIVITY_USER = "TRANSACTION_ACTIVITY_USER";

export const DASHBOARD_TRANSACTIONS = "DASHBOARD_TRANSACTIONS";
export const DASHBOARD_TRANSACTIONS_VALUE = "DASHBOARD_TRANSACTIONS_VALUE";
export const DASHBOARD_TASKS = "DASHBOARD_TASKS";

export const DASHBOARD_COMMISSION = "DASHBOARD_COMMISSION";
export const DASHBOARD_TASK_LIST = "DASHBOARD_TASK_LIST";

export const BUYERS_LIST = "BUYERS_LIST";

export const GET_ADD_FROM_ZIPCODE = "GET_ADD_FROM_ZIPCODE";

export const LIST_ADMIN_USERS = "LIST_ADMIN_USERS";
export const ADD_ADMIN_USER = "ADD_ADMIN_USER";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

export const CHECK_SHORT_NAME = "CHECK_SHORT_NAME";

export const DISC_THREADS = "DISC_THREADS";
export const MESSAGES_LIST = "MESSAGES_LIST";
export const REPLY_MSG = "REPLY_MSG";
export const RESEND_MSG = "RESEND_MSG";

export const EMAIL_TEMPLATES = "EMAIL_TEMPLATES";
export const UPDATE_EMAIL_TEMPLATE = "UPDATE_EMAIL_TEMPLATE";

export const ADMIN_SYS_NOTIFICATION = "ADMIN_SYS_NOTIFICATION";
export const USER_NOTIFICATIONS = "USER_NOTIFICATIONS";
export const NOTIFICATIONS_LISTING = "NOTIFICATIONS_LISTING";
export const USER_NOTIFICATIONS_SETTINGS = "USER_NOTIFICATIONS_SETTINGS";
export const UPDATE_NOTIFICATIONS_SETTINGS = "UPDATE_NOTIFICATIONS_SETTINGS";
export const READ_NOTIFICATIONS = "READ_NOTIFICATIONS";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";

export const SUBSCRIPTION_DATA = "SUBSCRIPTION_DATA";
export const ADD_SUBSCRIPTION = "ADD_SUBSCRIPTION";
export const GET_ALL_SUBSCRIPTION = "GET_ALL_SUBSCRIPTION";
export const DELETE_IMAGE = "DELETE_IMAGE";
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const ARCHIVE_SUBSCRIPTION = "ARCHIVE_SUBSCRIPTION";
export const ACCOUNT_INFO = "ACCOUNT_INFO";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const ADD_PAYMENT = "ADD_PAYMENT";
export const UPDATE_PAYMENT_METHOD = "UPDATE_PAYMENT_METHOD";
export const REMOVE_PAYMENT_METHOD = "REMOVE_PAYMENT_METHOD";
export const GET_PRORATION = "GET_PRORATION";
export const CHANGE_SUBSCRIPTION = "CHANGE_SUBSCRIPTION";
export const REACTIVATE_PLAN = "REACTIVATE_PLAN";
export const ACTIVATE_PLAN = "ACTIVATE_PLAN";
export const INVOICE_LIST = "INVOICE_LIST";
export const STRIPE_SETTING = "STRIPE_SETTING";
export const INVITED_USER = "INVITED_USER";
export const PENDING_PROFILE = "PENDING_PROFILE";
export const UPDATE_PLAN_SETTING = "UPDATE_PLAN_SETTING";
export const SUBSCRIPTION_PROVIDER = "SUBSCRIPTION_PROVIDER";
export const UPDATE_PLAN_PROVIDER = "UPDATE_PLAN_PROVIDER";

export const GET_HEAR_ABOUT_US = "GET_HEAR_ABOUT_US";
export const TRANSACTION_TYPE = "TRANSACTION_TYPE";

export const ADD_PUBLIC_FORM = "ADD_PUBLIC_FORM";
export const UPDATE_PUBLIC_FORM = "UPDATE_PUBLIC_FORM";
export const DELETE_PUBLIC_FORM = "DELETE_PUBLIC_FORM";
export const GET_PUBLIC_FORM_BY_ID = "GET_PUBLIC_FORM_BY_ID";
export const IS_PUBLIC_FORM_VALID = "IS_PUBLIC_FORM_VALID";

export const ADD_BILLING_CONFIG = "ADD_BILLING_CONFIG";
export const BILLING_HISTORY = "BILLING_HISTORY";
export const BILLING_PAYMENT_CAPTURE = "BILLING_PAYMENT_CAPTURE";
export const BILLING_PAYMENT_DETAILS = "BILLING_PAYMENT_DETAILS";
export const CREATE_OR_UPDATE_INVOICE = "CREATE_OR_UPDATE_INVOICE";

export const BILLING_SETTING = "BILLING_SETTING";
export const EDIT_BILLING_CONFIG = "EDIT_BILLING_CONFIG";
export const CHANGE_BILLING_PLAN = "CHANGE_BILLING_PLAN";
export const GET_CURRENT_CREDIT = "GET_CURRENT_CREDIT";
export const UPDATE_CURRENT_CREDIT = "UPDATE_CURRENT_CREDIT";
export const UPDATE_AUTH_DB = "UPDATE_AUTH_DB";
export const GET_ALL_VENDOR_CONTINGENCIES = "GET_ALL_VENDOR_CONTINGENCIES";
export const RENDERSIDEBAR = "RENDERSIDEBAR";
export const RENDERHEADER = "RENDERHEADER";
export const ADD_PATHWAY_TO_TRANSACTION = "ADD_PATHWAY_TO_TRANSACTION";
export const TRANSACTION_PATHWAYS_LIST = "TRANSACTION_PATHWAYS_LIST";
export const REMOVE_TRANSACTION_PATHWAY = "REMOVE_TRANSACTION_PATHWAY";

export const GET_SYSTEMBANNERS = "GET_SYSTEMBANNERS";
export const ADD_SYSTEMBANNERS = "ADD_SYSTEMBANNERS";
export const GET_SYSTEMBANNER_DETAILS = "GET_SYSTEMBANNER_DETAILS";

export const GET_TRANS_TOTAL_PAYMENT = "GET_TRANS_TOTAL_PAYMENT";
export const GET_All_SHOPS = "GET_All_SHOPS";

export const GET_ARTIST_AVAILABLE_DATES = "GET_ARTIST_AVAILABLE_DATES";
